export default import.meta.ROLLUP_FILE_URL_JK$lDRY_;